import React from 'react';
import { createPortal } from 'react-dom';

// Renders an SR-only polite live region as a portal to <body>, escaping the
// chat's aria-live="off" log container so NVDA actually announces the text.
// Empty-then-text pattern (matching CustomMessages) ensures the announcement
// fires once on insertion.
export function TicketStatusAnnouncement({ message }: { message: string }) {
  const [announcement, setAnnouncement] = React.useState('');
  React.useEffect(() => {
    if (!message) return undefined;
    setAnnouncement('');
    const id = requestAnimationFrame(() => setAnnouncement(message));
    return () => cancelAnimationFrame(id);
  }, [message]);
  return createPortal(
    <div className="copilot-sr-only" role="status" aria-live="polite" aria-atomic="true">
      {announcement}
    </div>,
    document.body
  );
}
